import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/nightOwl";
import { Pre, Line, LineNo, LineContent } from "./styles";

// C# Sample Code for Post Journal Entry
const csharp = `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Post, "baseurl/API/JournalEntry/PostJournalEntry");
request.Headers.Add("Authorization", "Bearer bearer abc");
var content = new StringContent("{\r\n  \"backofficeAccountNumber\": \"sqL4-JmFS-980734-wp\",\r\n  \"transactionType\": \"Deposit\",\r\n  \"amount\": 0.01,\r\n  \"externalId\": \"string\",\r\n  \"tradeDate\": \"2025-05-15T06:29:46.495Z\"\r\n}", null, "application/json");
request.Content = content;
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());
`;

function HTTPPostJournalEntryCsharp() {
  return (
    <Highlight {...defaultProps} theme={theme} code={csharp} language="csharp">
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPPostJournalEntryCsharp;
